const React = require("react");
const AssetsUtil = require("../../core/util/AssetsUtil");
const Link = require("../../core/view/Link");
const {
	inlineIcon,
	teacherIcon,
	genericIcon,
	detailIcon,
	screenshot,
} = require("../../core/util/CopyShared");

const getCopy = function(styles, options = {}) {
	const assetNameWithType = name => `${name}${"Teacher"}`;

	const assignmentsLink = (
		<Link
			to={options.supportLinkURL("play", "assignments")}
			className={styles.link}
		>
			Assignments
		</Link>
	);

	const getSliderLink = () => assignmentsLink;

	return [
		{
			hash: "overview",
			titleLevel: 1,
			contents: (
				<div className={styles.rowContainer}>
					<div className={styles.column6}>
						<div className={styles.overviewText}>
							This page explains what Beast Academy looks like from a student's
							perspective and how each main area works.
						</div>
						<br />
						<div className={styles.teacherBox}>
							<div className={styles.blockWithLeftWing}>
								<div className={styles.leftWing}>{teacherIcon(styles)}</div>
								<div>
									Your teacher account has a few tools that students don’t see.
									Notes about your special Teacher tools will look like this.
								</div>
							</div>
						</div>
						<br />
						<div className={styles.videoArea}>
							<iframe
								className={styles.video}
								src="https://www.youtube.com/embed/k11E0UHgDj0"
								allow="autoplay; encrypted-media"
								frameBorder="0"
								allowFullScreen
							/>
						</div>
					</div>
					<div className={styles.column4}>
						<div className={styles.tableOfContents}>
							<div className={styles.tocHeader}>CONTENTS</div>
							<ul className={styles.blueBulletList}>
								<li>
									<Link
										to={options.supportLinkURL("play", "getting-around")}
										className={styles.link}
									>
										Getting Around
									</Link>
									<ul className={styles.redSquareBulletList}>
										<li>
											<Link
												to={options.supportLinkURL("play", "home-screen")}
												className={styles.link}
											>
												Home Screen
											</Link>
										</li>
										<li>
											<Link
												to={options.supportLinkURL("play", "navigation-bar")}
												className={styles.link}
											>
												Navigation Bar
											</Link>
										</li>
									</ul>
								</li>
								<li>
									<Link
										to={options.supportLinkURL("play", "learning-and-practice")}
										className={styles.link}
									>
										Learning And Practice
									</Link>
									<ul className={styles.redSquareBulletList}>
										<li>
											<Link
												to={options.supportLinkURL("play", "library")}
												className={styles.link}
											>
												Library
											</Link>
										</li>
										<li>
											<Link
												to={options.supportLinkURL("play", "class")}
												className={styles.link}
											>
												Class
											</Link>
										</li>
										<li>
											<Link
												to={options.supportLinkURL("play", "theater")}
												className={styles.link}
											>
												Theater
											</Link>
										</li>
										<li>
											<Link
												to={options.supportLinkURL("play", "puzzle-lab")}
												className={styles.link}
											>
												Puzzle Lab
											</Link>
										</li>
									</ul>
								</li>
								<li>
									<Link
										to={options.supportLinkURL("play", "tracking-progress")}
										className={styles.link}
									>
										Tracking Progress
									</Link>
									<ul className={styles.redSquareBulletList}>
										<li>
											<Link
												to={options.supportLinkURL("play", "profile")}
												className={styles.link}
											>
												Profile
											</Link>
										</li>
									</ul>
								</li>
								<li>
									<Link
										to={options.supportLinkURL("play", "beastbuilder")}
										className={styles.link}
									>
										Beast Builder
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "getting-around",
			title: "Getting Around",
			titleLevel: 1,
			contents: (
				<div>
					In Beast Academy, you have three tools for navigation:
					<ul className={styles.redSquareBulletList}>
						<li>
							<Link
								to={options.supportLinkURL("play", "home-screen")}
								className={styles.link}
							>
								Home Screen
							</Link>
						</li>
						<li>
							<Link
								to={options.supportLinkURL("play", "navigation-bar")}
								className={styles.link}
							>
								Navigation Bar
							</Link>
						</li>
						<li>{getSliderLink()}</li>
					</ul>
				</div>
			),
		},
		{
			hash: "home-screen",
			title: "Home Screen",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							Each time you sign in to Beast Academy as a student, you'll start
							at the Home Screen.
							<p>
								{"From the Home Screen, you can visit the "}
								<Link
									to={options.supportLinkURL("play", "library")}
									className={styles.link}
								>
									Library
								</Link>
								{", the "}
								<Link
									to={options.supportLinkURL("play", "class")}
									className={styles.link}
								>
									Class
								</Link>
								{", the "}
								<Link
									to={options.supportLinkURL("play", "theater")}
									className={styles.link}
								>
									Theater
								</Link>
								{", and the "}
								<Link
									to={options.supportLinkURL("play", "puzzle-lab")}
									className={styles.link}
								>
									Puzzle Lab
								</Link>
								{" by clicking the button on any of these buildings."}
							</p>
							<div className={styles.textWithIcon}>
								{
									"You can go back to the Home Screen at any time by clicking the "
								}
								<div className={styles.baHomeTopBarOuter}>
									{genericIcon(
										styles,
										AssetsUtil.getScreenshot("baHomeTopBar"),
										"baHomeTopBarOuter",
										"baHomeTopBarIcon"
									)}
								</div>
								{" in the "}
								<Link
									to={options.supportLinkURL("play", "navigation-bar")}
									className={styles.link}
								>
									Navigation Bar
								</Link>
								{" at the top of the window."}
							</div>
							<p>
								{"You can also move around by using the "}
								{getSliderLink()}
								{" on the top left."}
							</p>
							<p>
								To sign out of Beast Academy,{" "}
								<b>
									hover over on your name in the top right and click sign out.
								</b>
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("homePage"), true)}
						</div>
					</div>

					<div>
						<div className={styles.teacherBox}>
							<div className={styles.blockWithLeftWing}>
								<div className={styles.leftWing}>
									{genericIcon(
										styles,
										AssetsUtil.getScreenshot("teacherCircle"),
										"teacherCircleOuter",
										"teacherCircleIcon"
									)}
								</div>
								<div>
									When you're using Beast Academy as a teacher, you'll see a
									special Teacher Menu in the top left corner. Clicking on it
									from the <b>Home Screen</b>, the <b>Library</b>, the{" "}
									<b>Theater</b> or the <b>Puzzle Lab</b> will take you to your
									students' <b>Reports</b>.
								</div>
							</div>
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "navigation-bar",
			title: "Navigation Bar",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					The Navigation Bar is always at the top of your window. It includes
					the following buttons:
					<br />
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getScreenshot("baHomeTopBar"),
						<span>
							<b>Home:</b>
							{" Takes you back to the "}
							<Link
								to={options.supportLinkURL("play", "home-screen")}
								className={styles.link}
							>
								Home Screen
							</Link>
							.
						</span>,
						styles["baHomeTopBarDetailIcon"]
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("bell"),
						<span>
							<b>Class:</b>
							{" Takes you to the "}
							<Link
								to={options.supportLinkURL("play", "class")}
								className={styles.link}
							>
								Class
							</Link>
							{" to practice math."}
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("book"),
						<span>
							<b>Library:</b>
							{" Takes you to the "}
							<Link
								to={options.supportLinkURL("play", "library")}
								className={styles.link}
							>
								Library
							</Link>
							{" to read from the Beast Academy Guide books."}
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("projector"),
						<span>
							<b>Theater:</b>
							{" Takes you to the "}
							<Link
								to={options.supportLinkURL("play", "theater")}
								className={styles.link}
							>
								Theater
							</Link>
							{" to watch Videos about new topics."}
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("help"),
						<span>
							<b>Help:</b> Gives you tips about the page that you are on.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("settings"),
						<span>
							<b>Settings:</b> Lets you adjust sounds, music, and other gameplay
							basics.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						{num: "student"}, // default student avatar
						<span>
							<b>Profile:</b> Shows information about your progress through
							Beast Academy.
						</span>,
						styles.detailAvatar
					)}
				</div>
			),
		},
		{
			hash: "enrichment",
			title: "Enrichment",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.enrichmentLeft}>
							<p>
								Enrichment lessons are found upstairs. These lessons go beyond
								what is typically taught in most classrooms and may be
								considered optional. They are great for students who could use
								an extra challenge or want to learn a new topic.
							</p>
							<p>
								Enrichment lessons are not included in part 1 of each Chapter
								Test.
							</p>
							<div className={styles.textWithIcon}>
								{
									"A student can access the Enrichment lessons by clicking on any unlocked upstairs icon "
								}
								<div className={styles.buttonCircleOuter}>
									{genericIcon(
										styles,
										AssetsUtil.getButtonCircle("upstairs"),
										"buttonCircleOuter",
										"buttonCircleInner"
									)}
								</div>
								.
							</div>
							<br />
							<div className={styles.textWithIcon}>
								{
									"When they have completed the Enrichment lesson, students can return to the main floor core by clicking on any unlocked downstairs icon "
								}
								<div className={styles.buttonCircleOuter}>
									{genericIcon(
										styles,
										AssetsUtil.getButtonCircle("downstairs"),
										"buttonCircleOuter",
										"buttonCircleInner"
									)}
								</div>
								.
							</div>
						</div>
						<div className={styles.enrichmentRight}>
							{screenshot(styles, "playUpstairsIcon", true)}
							{screenshot(styles, "playEnrichmentLesson", true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "assignments",
			title: "Assignments",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div className={styles.rowContainer}>
					<div className={styles.column6}>
						{
							"The Assignments tab is always at the top left of your window. Click on "
						}
						{inlineIcon(
							styles,
							AssetsUtil.getScreenshot("assignmentsTabButton"),
							"assignmentsTabButtonOuter",
							"assignmentsTabButtonIcon"
						)}
						{" to open it."}
						<p>
							At the top, it shows a list of all incomplete assigned lessons in
							the order in which they appear in BA Online. Lessons move to the
							completed section once they are starred. If there are no
							assignments, the section will not appear.
						</p>
						<p>To close the Assignments tab, just click outside it.</p>
						<div>
							{detailIcon(
								styles,
								AssetsUtil.getHWIcon(false),
								<span>
									<b>A red icon indicates an incomplete assignment.</b>
								</span>
							)}
							<br />
							{detailIcon(
								styles,
								AssetsUtil.getHWIcon(false, true),
								<span>
									<b>A green icon indicates a complete assignment.</b>
								</span>
							)}
						</div>
					</div>
					<div className={styles.column4}>
						{screenshot(styles, "assignmentsTab", false)}
					</div>
				</div>
			),
		},
		{
			hash: "learning-and-practice",
			title: "Learning And Practice",
			titleLevel: 1,
			contents: (
				<div>
					<p>The four main areas of Beast Academy Online are:</p>
					<ul className={styles.redSquareBulletList}>
						<li>
							{"The "}
							<Link
								to={options.supportLinkURL("play", "library")}
								className={styles.link}
							>
								Library
							</Link>
							{", where you can read Chapters of the "}
							<Link
								to={options.supportLinkURL("play", "guide-book")}
								className={styles.link}
							>
								Guide book
							</Link>
							.
						</li>
						<li>
							{"The "}
							<Link
								to={options.supportLinkURL("play", "class")}
								className={styles.link}
							>
								Class
							</Link>
							{
								", where you can practice math by solving problems and puzzles in the "
							}
							<Link
								to={options.supportLinkURL("play", "lessons")}
								className={styles.link}
							>
								Lessons
							</Link>
							{" and "}
							<Link
								to={options.supportLinkURL("play", "tests")}
								className={styles.link}
							>
								Tests
							</Link>
							.
						</li>
						<li>
							{"The "}
							<Link
								to={options.supportLinkURL("play", "theater")}
								className={styles.link}
							>
								Theater
							</Link>
							{", where you can watch "}
							<Link
								to={options.supportLinkURL("play", "videos")}
								className={styles.link}
							>
								Videos
							</Link>
							{" about the topics in your lessons."}
						</li>
						<li>
							{"The "}
							<Link
								to={options.supportLinkURL("play", "puzzle-lab")}
								className={styles.link}
							>
								Puzzle Lab
							</Link>
							{
								", where you can solve fun puzzles to practice your problem-solving skills."
							}
						</li>
					</ul>
				</div>
			),
		},
		{
			hash: "library",
			title: "Library",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							<p>
								The Library is where you can find all the illustrated Beast
								Academy Guide books.
							</p>
							{"To go to the Library, click the "}
							{inlineIcon(styles, AssetsUtil.getButton("book"))}
							{" icon from the "}
							<Link
								to={options.supportLinkURL("play", "navigation-bar")}
								className={styles.link}
							>
								Navigation Bar
							</Link>
							{" or use the button in front of the Library building on the "}
							<Link
								to={options.supportLinkURL("play", "home-screen")}
								className={styles.link}
							>
								Home Screen
							</Link>
							{"."}
							<p>
								The Library shows you all the Chapters in a BA Level. Click on
								any Chapter to start reading the Guide.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("libraryPage"), true)}
						</div>
					</div>
					<p>
						You can click these icons to jump to the Beast Academy Guides for a
						different level:
					</p>
					{detailIcon(
						styles,
						AssetsUtil.getButton("left"),
						<span>
							<b>Previous Level:</b> Click the arrow on the left side of the
							window to go to the Guides from the previous level in Beast
							Academy.
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("right"),
						<span>
							<b>Next Level:</b> Click the arrow on the right side of the window
							to go to the Guides for the next level in Beast Academy.
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("index"),
						<span>
							<b>View All Chapters:</b> Click the View All Chapters Menu at the
							top of the window to see a list of all the chapters in every level
							of Beast Academy.
						</span>
					)}
				</div>
			),
		},
		{
			hash: "guide-book",
			title: "Guide book",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							Students can access every chapter of the Beast Academy Guide books
							from the Library.
							<p>
								You can scroll through the digital pages of the Guide books in
								different ways:
							</p>
							<ul>
								<li>Using your mouse.</li>
								<li>
									Using the arrow or Page Up / Page Down keys on your keyboard.
								</li>
								<li>Touching and dragging on a tablet.</li>
							</ul>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("bookPage"), true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "guide-navigation",
			title: "Navigation",
			titleLevel: 4,
			contents: (
				<div className={styles.rowContainer}>
					<div className={styles.column4}>
						<div>
							{"To see the "}
							<Link
								to={options.supportLinkURL("play", "navigation-bar")}
								className={styles.link}
							>
								Navigation Bar
							</Link>
							{" while you're reading the Guide, click the "}
							{inlineIcon(styles, AssetsUtil.getButton("arrow-down"))}
							{" at the top of the screen."}
							<br />
							<br />
							{"Click the "}
							{inlineIcon(
								styles,
								AssetsUtil.getButton("arrow-down"),
								null,
								"up"
							)}
							{" again to hide the Navigation Bar."}
							<br />
							<br />
							The Scroll Bar on the right side lets you move through the Guide.
							<br />
							<br />
							{"Click the "}
							{inlineIcon(
								styles,
								AssetsUtil.getButton("arrow-down"),
								null,
								"left"
							)}
							{" next to the Scroll Bar to expand it and view section titles."}
							<p>
								The top of the Scroll Bar shows the name of the Chapter. You can
								click the left or right arrow to move to a different Chapter.
							</p>
						</div>
						<div className={styles.title4}>Zoom</div>
						The view buttons on the left change what you see:
						<ul>
							<li>
								{inlineIcon(styles, AssetsUtil.getButton("zoom-in"))} Zooms in
								to make the Guide bigger.
							</li>
							<li>
								{inlineIcon(styles, AssetsUtil.getButton("zoom-out"))} Zooms out
								to make the Guide smaller.
							</li>
							<li>
								{inlineIcon(styles, AssetsUtil.getButton("book-blue"))}
								{" Takes you back to the "}
								<Link
									to={options.supportLinkURL("play", "library")}
									className={styles.link}
								>
									Library
								</Link>
								.
							</li>
						</ul>
					</div>
					<div className={styles.column6}>
						{screenshot(
							styles,
							assetNameWithType("bookPageWithNavigationBar"),
							true
						)}
					</div>
				</div>
			),
		},
		{
			hash: "class",
			title: "Class",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						{"To go to the Class, click the "}
						{inlineIcon(styles, AssetsUtil.getButton("bell"))}
						{" icon from the Navigation Bar or "}
						{
							"use the button in front of the Class building on the Home Screen."
						}
					</div>
					<div className={styles.column6}>
						{screenshot(styles, assetNameWithType("classPage"), true)}
					</div>
				</div>
			),
		},
		{
			hash: "class-icons",
			title: "Icons",
			titleLevel: 3,
			contents: (
				<div>
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("locked"),
						<span>
							<b>Locked:</b> A locked Lesson can’t be played yet. You’ll have to
							earn stars on previous Lessons to unlock it.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("bell"),
						<span>
							<b>Unlocked Lesson:</b> This is an unlocked available Lesson with
							no progress.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("bell-partial-progress"),
						<span>
							<b>Partial Progress:</b> As you make progress on a Lesson, the
							outer ring will turn gold.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("1-star"),
						<span>
							<b>Completed Lesson:</b> A check mark indicates a completed
							Lesson.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("3-star"),
						<span>
							<b>Stars:</b> The number of stars in your completed Lesson shows
							how many stars you have earned on your best attempt.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("monster"),
						<span>
							<b>Enrichment:</b> Lessons with a monster icon go beyond what is
							typically taught in most classrooms. These are great for when you
							need a challenge or if you want to learn a new topic.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("upstairs"),
						<span>
							<b>Upstairs:</b> These lessons are located upstairs.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("downstairs"),
						<span>
							<b>Downstairs:</b> To return to the core curriculum click the
							downstairs button.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getTrainerIcon("trophy"),
						<span>
							<b>Available Trophy Problem:</b> In some Lessons, you can uncover
							a special bonus trophy problem by earning enough stars on the
							lesson. Click the Available Trophy Problem icon to try it out!
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getTrainerIcon("trophy", true),
						<span>
							<b>Trophy:</b> You can win trophies by finishing trophy problems.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("find-my-avatar-with-default-avatar"),
						<span>
							<b>Find My Avatar:</b> If you lose your avatar in the hallway
							click this icon to make it jump! This button is found in the
							bottom right hand corner of the hallway.
						</span>
					)}
				</div>
			),
		},
		{
			hash: "class-navigation",
			title: "Navigation",
			titleLevel: 3,
			contents: (
				<div>
					You can jump to different Chapters using these icons:
					<br />
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonChapterCircle(1),
						<span>
							<b>Previous Chapter:</b> The button at the beginning of the
							hallway takes you to the previous chapter.
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonChapterCircle(3),
						<span>
							<b>Next Chapter:</b> The button at the end of the hallway takes
							you to the next chapter (you may need to scroll the bar at the
							bottom to the far right).
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("index"),
						<span>
							<b>View All Chapters:</b> Click the Chapter Menu at the top of the
							window to jump to a different Chapter in any level of Beast
							Academy.
						</span>
					)}
				</div>
			),
		},
		{
			hash: "lessons",
			title: "Lessons",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							The Lessons are where students practice math in a specific topic
							to earn stars and trophies.
							<br />
							<br />
							Tools within the Lesson tell you about your progress, help you
							jump to other areas, and let you make notes as you solve problems.
							<br />
							<br />
							In some problems, you may see a keyboard at the bottom of the
							Lesson window. You can use this keyboard to type, or you can use
							the keyboard on your computer. Some Lessons don’t require a
							keyboard at all.
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("playPage"), true)}
						</div>
					</div>
					<br />

					<div className={styles.teacherBox}>
						<div className={styles.blockWithLeftWing}>
							<div className={styles.leftWing}>
								{genericIcon(
									styles,
									AssetsUtil.getScreenshot("teacherCircle"),
									"teacherCircleOuter",
									"teacherCircleIcon"
								)}
							</div>
							<div>
								When you play a Lesson as a teacher, your Teacher Menu has three
								options:
							</div>
						</div>
						<ul className={styles.teacherMenuList}>
							<li>
								<b>Restart Problem Set</b> lets you start the Lesson over.
							</li>
							<li>
								<b>Switch Problem Set</b> lets you switch to any of the other
								Problem Sets in this Lesson. Most lessons have three Problem
								Sets!
							</li>
							<li>
								<b>Reports</b> takes you to your students' Reports.
							</li>
						</ul>
					</div>
				</div>
			),
		},
		{
			hash: "lessons-instructions",
			title: "Instructions",
			titleLevel: 4,
			contents: (
				<div>
					Every Lesson begins with instructions. You can re-open instructions
					that you have closed by clicking the{" "}
					{inlineIcon(styles, AssetsUtil.getButton("info-black"))} on the right
					side of the Lesson window.
					<br />
					<br />
					<div className={styles.teacherBox}>
						<div className={styles.blockWithLeftWing}>
							<div className={styles.leftWing}>{teacherIcon(styles)}</div>
							<div className={styles.teacherTextWithButtons}>
								{
									" When you’re solving a problem in a Lesson as a teacher, you’ll see the "
								}
								{genericIcon(
									styles,
									AssetsUtil.getScreenshot("show-solution"),
									"teacherButtonOuter",
									"teacherButtonIcon"
								)}
								{
									" button in the bottom-right. Click the button for an explanation of the answer."
								}
							</div>
						</div>
						<div
							className={
								styles.teacherTextWithButtons + " " + styles.teacherTextIndent
							}
						>
							{"After you’ve answered a problem in a Lesson, you’ll see the "}
							{genericIcon(
								styles,
								AssetsUtil.getScreenshot("replay-problem"),
								"teacherButtonOuter",
								"teacherButtonIcon"
							)}{" "}
							button on the bottom-left. Click the button to play through the
							problem again.
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "lessons-progress",
			title: "Progress",
			titleLevel: 4,
			contents: (
				<div>
					As you work through a Lesson, the Progress Bar at the top of the
					window shows you how many stars you’re earning.
					<br />
					<br />
					You can earn up to three stars in a Lesson. Most lessons have three
					different problem sets, so you can play a lesson multiple times
					without repeating problems.
					<br />
					<br />
					Every Lesson has a Lesson Title under the Progress Bar.
					<br />
					<br />
					{screenshot(
						styles,
						assetNameWithType("lessonTitleAndProgressBar"),
						false
					)}
				</div>
			),
		},
		{
			hash: "lessons-navigation",
			title: "Navigation",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Tools to the left and right of the Lesson Title will help you
						navigate:
					</p>
					<ul>
						<li>
							{"Click the "}
							{inlineIcon(styles, AssetsUtil.getButtonChapterCircle(7))}
							{" to return to the hallway to access other lessons."}
						</li>
						<li>
							{"Click the "}
							{inlineIcon(styles, AssetsUtil.getButtonCircle("play"))} to watch
							linked Videos. (If there are no linked Videos for your Lesson,
							this button will not appear.)
						</li>
						<li>
							{"Click the "}
							{inlineIcon(styles, AssetsUtil.getButtonCircle("bookmark"))}
							{" to read the most relevant Guide book section for any Lesson."}
						</li>
					</ul>
					<p>
						You can switch between problems by clicking on the circles under the
						lesson title. The larger circle is the problem you are currently
						playing.
					</p>
					{options.setButton(
						{
							problemNumber: 1,
							selectable: false,
						},
						<span>
							<b>Locked:</b> You have not unlocked this problem yet. You’ll have
							to answer previous problems correctly to unlock it.
						</span>
					)}
					<br />
					{options.setButton(
						{
							problemNumber: 1,
							selectable: true,
						},
						<span>
							<b>Unanswered:</b> You have not answered this problem yet.
						</span>
					)}
					<br />
					{options.setButton(
						{
							percentComplete: 1,
							problemNumber: 1,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						<span>
							<b>Correct:</b> You answered this problem correctly!
						</span>
					)}
					<br />
					{options.setButton(
						{
							percentComplete: 0.5,
							problemNumber: 1,
							selectable: true,
						},
						<span>
							<b>In Progress:</b> Your first answer was incorrect, but you can
							try again.
						</span>
					)}
					<br />
					{options.setButton(
						{
							percentComplete: 1,
							problemNumber: 1,
							isCorrect: false,
							selectable: true,
							isComplete: true,
						},
						<span>
							<b>Incorrect:</b> All the answers you entered for this problem
							were incorrect.
						</span>
					)}
				</div>
			),
		},
		{
			hash: "lessons-drawing-tools",
			title: "Drawing Tools",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						There are optional drawing tools on the left side of the Lesson
						window. Here's how the drawing tools work:
					</p>
					{detailIcon(
						styles,
						AssetsUtil.getButton("pencil-on"),
						<span>
							Click the pencil to start drawing. Click the pencil again to stop
							drawing.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("eraser-on"),
						<span>
							Click the eraser to start erasing your pencil marks. Click the
							eraser again to stop erasing.
						</span>
					)}
					<p>
						<b>
							Remember that the notes you make with the drawing tools will not
							count as part of your final answer!
						</b>
					</p>
				</div>
			),
		},
		{
			hash: "tests",
			title: "Tests",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							Tests are available for every chapter in BA Online.
							<br />
							<br />
							Every Beast Academy chapter test has two parts. Part 1 covers the
							essential concepts and skills learned over the course of the
							chapter. Students who do well on Part 1 earn a star and unlock
							Part 2.
							<br />
							<br />
							Part 2 has fewer, more difficult problems and is not required, but
							offers an opportunity for students to apply their understanding
							and earn up to two additional stars.
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("testOnChapterPage"), true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "tests-unlocking",
			title: "Unlocking the Test",
			titleLevel: 4,
			contents: (
				<div>
					Students must earn at least one star on all but two of the downstairs
					lessons in a chapter to unlock the chapter test.
					<br />
					<br />
					There are two ways to override this requirement:
					<ul>
						<li>
							Teachers can manually
							{` `}
							<Link
								to={options.supportLinkURL("reports", "locks")}
								className={styles.link}
							>
								unlock any locked test
							</Link>
							{` `}
							from their Report page.
						</li>
						<li>
							Teachers may choose the Free Play lock scheme from the
							{` `}
							<Link
								to={options.supportLinkURL("account", "subscriptions-tab")}
								className={styles.link}
							>
								Subscriptions tab
							</Link>
							{` `}
							and check the box to unlock all tests.
						</li>
					</ul>
					{screenshot(
						styles,
						"freePlayWithCheckbox",
						false,
						styles.freePlayWithCheckbox
					)}
				</div>
			),
		},
		{
			hash: "tests-taking",
			title: "Taking the Test",
			titleLevel: 4,
			contents: (
				<div>
					<div className={styles.textWithIcon}>
						{
							"To take a test, scroll to the very end of the hallway and click the "
						}
						<div className={styles.buttonCircleOuter}>
							{genericIcon(
								styles,
								AssetsUtil.getButtonCircle("test"),
								"buttonCircleOuter",
								"buttonCircleInner"
							)}
						</div>
						{" icon"}
						{"."}
					</div>
					<br />
					Once a student starts a test, all other sections of BA Online will be
					locked until the student submits or quits the test.{" "}
					<b>So, students should not begin a test until they are ready.</b>
					<br />
					<br />
					Tests work differently from lessons in several important ways.
					<ul>
						<li>Students don’t submit answers as they go.</li>
						<li>Students don’t get second chances when they miss problems.</li>
						<li>Students can skip around and answer questions in any order.</li>
						<li>
							Students save their answers and can edit them as needed before
							submitting all of the questions in each part. Problem circles for
							problems that have saved answers are yellow.
						</li>
					</ul>
					{screenshot(
						styles,
						"testProgressIndicators",
						false,
						styles.testProgressIndicators
					)}
					<br />
					<br />
					Each test has <b>two parts.</b>
					<ul>
						<li>
							<b>Part 1</b> tests the essential skills and topics found in the
							chapter. Part 1 has either 12 or 15 questions. If a student
							answers more than 70% of the problems in Part 1 correctly, they
							earn a star and can move on to Part 2.
						</li>
						<li>
							<b>Part 2</b> is optional and has more challenging questions than
							Part 1. Part 2 has either 4 or 5 questions. Students earn up to 2
							additional stars (up to 3 total) based on their overall
							performance on both parts 1 and 2.
						</li>
					</ul>
					<div className={styles.teacherBox}>
						<div className={styles.blockWithLeftWing}>
							<div className={styles.leftWing}>
								{genericIcon(
									styles,
									AssetsUtil.getScreenshot("teacherCircle"),
									"teacherCircleOuter",
									"teacherCircleIcon"
								)}
							</div>
							<div>
								When you play a Test as a teacher, your Teacher Menu has four
								options:
							</div>
						</div>
						<ul>
							<li>
								<b>Restart Problem Set</b> lets you start the Test over.
							</li>
							<li>
								<b>Switch Problem Set</b> lets you switch to any of the other
								Problem Sets in this Test.
							</li>
							<li>
								<b>Go to Part</b> lets you switch to the other part of the Test.
							</li>
							<li>
								<b>Reports</b> takes you to your students' Reports.
							</li>
						</ul>
					</div>
					<br />
					<b>Submitting Answers</b>
					<br />
					To submit either part of the test, view the Summary screen by clicking
					the Summary button or the{" "}
					{inlineIcon(
						styles,
						AssetsUtil.getBeastAvatar("headmaster", 3),
						"headmaster"
					)}{" "}
					icon. In Part 1, students must have a minimum number of answers saved
					to submit. There is no minimum number of answers needed to submit part
					2.
					<br />
					<br />
					<b>Quitting or Exiting</b>
					<br />
					<br />
					To exit a test without completing it, you must quit the test. If you
					quit a test, you must wait at least 24 hours to attempt the test
					again, or have your teacher
					<Link
						to={options.supportLinkURL("play", "tests-unlocking")}
						className={styles.link}
					>
						unlock
					</Link>{" "}
					it manually. To quit a test, visit the test summary screen and click
					the Quit Test button.
				</div>
			),
		},
		{
			hash: "tests-retaking",
			title: "Retaking a Test",
			titleLevel: 4,
			contents: (
				<div>
					There are two versions of every test. If a student quits a test or
					does not earn a star on their first attempt, they must wait at least
					24 hours to take the test again. This gives them the chance to review
					lessons. Teachers can override this 24-hour period with either of the{" "}
					<Link
						to={options.supportLinkURL("play", "tests-unlocking")}
						className={styles.link}
					>
						unlocking
					</Link>{" "}
					options above.
				</div>
			),
		},
		{
			hash: "tests-reviewing",
			title: "Reviewing a Test",
			titleLevel: 4,
			contents: (
				<div>
					After submitting a test, students see how many stars they earned,
					which problems they missed, and can review their submitted answers and
					full solutions to each problem. They can review their most recent test
					at any time by clicking the star icon on the test. Note that students
					cannot see questions and solutions on a test they have quit.
				</div>
			),
		},
		{
			hash: "theater",
			title: "Theater",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							<p>
								The Theater has videos that can help you understand the new
								topics you’re learning.
							</p>
							{"To go to the Theater, click the "}
							{inlineIcon(styles, AssetsUtil.getButton("projector"))}
							{" icon from the "}
							<Link
								to={options.supportLinkURL("play", "navigation-bar")}
								className={styles.link}
							>
								Navigation Bar
							</Link>
							{" or use the button in front of the Theater building on the "}
							<Link
								to={options.supportLinkURL("play", "home-screen")}
								className={styles.link}
							>
								Home Screen
							</Link>
							{"."}
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("theaterPage"), true)}
						</div>
					</div>
					<p>
						To watch a video, just click on it! Some topics may have more than
						one video.
					</p>
					<p>
						You can see the videos for another chapter by using these icons:
					</p>
					{detailIcon(
						styles,
						AssetsUtil.getButton("left"),
						<span>
							<b>Previous:</b> Click the arrow on the left side of the window to
							go to the videos for a previous Chapter.
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("right"),
						<span>
							<b>Next:</b> Click the arrow on the right side of the window to go
							to the videos for the next Chapter.
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("index"),
						<span>
							<b>View All Chapters:</b> Click the Chapter Menu button at the top
							of the window to jump to the videos for a different Chapter in any
							level of Beast Academy.
						</span>
					)}
				</div>
			),
		},
		{
			hash: "videos",
			title: "Videos",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							<p>
								The videos guide you through an example similar to the problems
								you’ll see in its corresponding Lesson.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("videoPage"), true)}
						</div>
					</div>
					<p>
						The Video Control Bar appears when you hover over the video screen:
					</p>
					{screenshot(styles, "videoControlBar", false)}
					<p>
						You can use the Video Control Bar to control the volume, pause, or
						move around in the video.
					</p>
					{"Use the "}
					{inlineIcon(
						styles,
						AssetsUtil.getTheaterIcon("cc-on"),
						"theaterLong"
					)}
					{" to turn closed captions on or off."}
				</div>
			),
		},
		{
			hash: "puzzle-lab",
			title: "Puzzle Lab",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							<p>
								To go to the Puzzle Lab, click the button in front of the Lab
								building on the{" "}
								<Link
									to={options.supportLinkURL("play", "home-screen")}
									className={styles.link}
								>
									Home Screen
								</Link>
								{"."}
							</p>
							<p>
								Students unlock the Puzzle Lab by completing enough work to
								reach XP level 10. Teachers can unlock the puzzle lab before
								then from the report pages, or by choosing the Free Play lock
								scheme and checking the Unlock Puzzle Lab option.
							</p>
							<p>
								Learn more in our{" "}
								<Link
									to={options.supportLinkURL("reports", "locks")}
									className={styles.link}
								>
									locks section
								</Link>
								.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, assetNameWithType("homePagePuzzleLab"), true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "puzzle-lab-icons",
			title: "Icons",
			titleLevel: 3,
			contents: (
				<div>
					<p>
						There are four difficulty levels for puzzle sets in BA Online. In
						order of difficulty, they are:
					</p>
					{detailIcon(
						styles,
						AssetsUtil.getCelestialImage("moon", true),
						<span>Moon sets are medium difficulty level.</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getCelestialImage("comet", true),
						<span>Comet sets are hard difficulty level.</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getCelestialImage("planet", true),
						<span>Planet sets are expert difficulty level.</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getCelestialImage("galaxy", true),
						<span>Galaxy sets are beast difficulty level.</span>
					)}
					<p>Completed puzzle sets turn from gray to yellow.</p>
				</div>
			),
		},
		{
			hash: "puzzle-lab-navigation",
			title: "Navigation",
			titleLevel: 3,
			contents: (
				<div>
					The Puzzle Lab includes lots of puzzle types. You can jump to
					different puzzle types using these icons:
					<br />
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("left"),
						<span>
							<b>Previous Type:</b> Click the arrow on the left side of the
							window to go to the previous Puzzle Type.
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("right"),
						<span>
							<b>Next Type:</b> Click the arrow on the right side of the window
							to go to the next Puzzle Type.
						</span>,
						true
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("index"),
						<span>
							<b>View All Types:</b> Click the Menu at the top of the window to
							view all of the available Puzzle Types.
						</span>
					)}
					<p>
						There is information about each puzzle type at the bottom of the
						page, including how students can unlock it and where to find more
						like it in the Beast Academy classroom.
					</p>
					<p>Click any unlocked puzzle set to play.</p>
				</div>
			),
		},
		{
			hash: "puzzle-lab-sets",
			title: "Puzzle Sets",
			titleLevel: 3,
			contents: (
				<div className={styles.rowContainer}>
					<div className={styles.column4}>
						<p>
							Puzzle sets vary in length. Once you finish all of the puzzles in
							a set, you earn the celestial object (moon, comet, planet, or
							galaxy) for the set. This will unlock other puzzle sets.
						</p>
						<p>
							Puzzle Sets play just like lessons with one exception: students
							have unlimited attempts at every puzzle. Because puzzles allow
							unlimited attempts, a puzzle is never marked as incorrect.
						</p>
						<p>
							Review the{" "}
							<Link
								to={options.supportLinkURL("play", "lessons")}
								className={styles.link}
							>
								Lessons
							</Link>{" "}
							section for information on instructions, navigation, and drawing
							tools within each Puzzle Set.
						</p>
					</div>
					<div className={styles.column6}>
						{screenshot(styles, assetNameWithType("puzzleSet"), true)}
					</div>
				</div>
			),
		},
		{
			hash: "tracking-progress",
			title: "Tracking Progress",
			titleLevel: 1,
			contents: null,
		},
		{
			hash: "profile",
			title: "Profile",
			titleLevel: 2,
			contents: (
				<div>
					The student Profile shows some of the same information that teachers
					can see about their students in their Reports tool.
				</div>
			),
		},
		{
			hash: "profile-tab",
			title: "Profile Tab",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							The <b>Profile</b> tab gives an overview of all the time that
							you've spent practicing math in BA Online.
						</p>
						<p>
							This is also where you can access{" "}
							<Link
								to={options.supportLinkURL("play", "beastbuilder")}
								className={styles.link}
							>
								Beast Builder
							</Link>{" "}
							to edit your monster avatar. Click the pencil icon next to your
							monster to open Beast Builder.
						</p>
					</div>
					<div className={styles.column6}>
						{screenshot(styles, assetNameWithType("profilePage"), true)}
					</div>
				</div>
			),
		},
		{
			hash: "progress-tab",
			title: "Progress Tab",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							The <b>Progress</b> tab gives detailed information about which
							Lessons, Tests, and Puzzle Sets you've played and how many stars
							and trophies you have earned.
						</p>
					</div>
					<div className={styles.column6}>
						{screenshot(styles, assetNameWithType("progressPage"), true)}
					</div>
				</div>
			),
		},
		{
			hash: "activity-tab",
			title: "Activity Tab",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							The <b>Activity</b> tab gives a calendar view of how much time
							you’ve spent working in Beast Academy and lists Lessons, Tests,
							and Puzzle Sets you’ve played, Guide book sections you’ve read,
							and Videos you’ve watched.
						</p>
						<p>Click any date to get information on what you did that day.</p>
					</div>
					<div className={styles.column6}>
						{screenshot(styles, assetNameWithType("activityPage"), true)}
					</div>
				</div>
			),
		},
		{
			hash: "assignments-tab",
			title: "Assignments Tab",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							The <b>Assignments</b> tab gives a list of all assigned lessons
							you have to complete. It also shows a list of all completed
							assignments.
						</p>
					</div>
					<div className={styles.column6}>
						{screenshot(styles, "assignmentsPage", true)}
					</div>
				</div>
			),
		},
		{
			hash: "beastbuilder",
			title: "Beast Builder",
			titleLevel: 1,
			contents: (
				<div className={styles.rowContainer}>
					<div className={styles.column4}>
						<p>
							Beast Builder is where you can spend Beast Bucks on parts to
							create your own monster avatar. You gain Beast Bucks by earning
							stars and trophies in lessons, and by gaining levels. You can see
							how many Beast Bucks you've earned below your name in the
							top-right corner.
						</p>
						<p>
							Access the Beast Builder by clicking the pencil icon next to your
							avatar on your profile page.
						</p>
					</div>
					<div className={styles.column6}>
						{screenshot(
							styles,
							assetNameWithType("beastBuilderButtonArrow"),
							true
						)}
					</div>
				</div>
			),
		},
		{
			hash: "beast-parts",
			title: "Parts Catalog",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.rowContainer}>
						<div className={styles.column4}>
							<p>
								Access parts to build your avatar in the menu on the left side
								of the screen.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(
								styles,
								assetNameWithType("beastBuilderPartShop"),
								true
							)}
						</div>
					</div>
					<div className={styles.rowContainer}>
						<div className={styles.column6}>
							<p>
								You have a limited amount to spend on beast parts.
								<br /> <b>Available</b> tells you how many Beast Bucks you have
								left to spend on beast parts.
								<br /> <b>Total</b> is the total number Beast Bucks you have
								earned.
							</p>
						</div>
						<div className={styles.column4}>
							{screenshot(styles, "bbBucks")}
						</div>
					</div>
					<div>
						Click {inlineIcon(styles, AssetsUtil.getBeastBuilderIcon("head"))}{" "}
						for head parts:
						<br />
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "eye"),
							<span>Eyes unlock at level 1.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "mouth"),
							<span>Mouths unlock at level 5.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "head"),
							<span>Heads unlock at level 14.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "ear"),
							<span>Ears and Horns unlock at level 17.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "hair"),
							<span>Hair unlocks at level 20.</span>
						)}
					</div>
					<br />
					<div>
						Click {inlineIcon(styles, AssetsUtil.getBeastBuilderIcon("body"))}{" "}
						for body parts:
						<br />
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "body"),
							<span>Body shapes unlock at level 1.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "leg"),
							<span>Legs unlock at level 8.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "arm"),
							<span>Arms unlock at level 11.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "tail"),
							<span>Tails unlock at level 23.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "wing"),
							<span>Wings unlocks at level 26.</span>
						)}
						<br />
						<div className={styles.rowContainer}>
							<div className={styles.column4}>
								<div>
									Click{" "}
									<div className={styles.bbButton}>
										See More{" "}
										{inlineIcon(
											styles,
											AssetsUtil.getTrainerIconButton("right")
										)}
									</div>{" "}
									to view a larger grid of parts.
								</div>
								<br />
								<div>
									Click <div className={styles.bbButton}>+</div> to add a part
									to your beast.
								</div>
							</div>
							<div className={styles.column6}>
								{screenshot(
									styles,
									assetNameWithType("beastBuilderPartsCatalog"),
									true
								)}
							</div>
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "beast-editing-parts",
			title: "Editing Your Avatar",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.rowContainer}>
						<div className={styles.column4}>
							<p>These action buttons are at the bottom of the screen:</p>
							<div>
								{detailIcon(
									styles,
									<div className={styles.bbSelectAll}>Select All</div>,
									<span>Selects all parts of your current avatar.</span>
								)}
								<br />
								{detailIcon(
									styles,
									AssetsUtil.getBeastBuilderButton("undo"),
									<span>Undo last change.</span>,
									styles.bbButtonSquare
								)}
								<br />
								{detailIcon(
									styles,
									AssetsUtil.getBeastBuilderButton("redo"),
									<span>Redo the last change undone.</span>,
									styles.bbButtonSquare
								)}
								<br />
								{detailIcon(
									styles,
									AssetsUtil.getBeastBuilderButton("photo"),
									<span>
										Access your photo gallery to take a picture or update your
										profile photo.
									</span>,
									styles.bbButtonSquare
								)}
							</div>
							<p>
								Select any part by clicking on it or by clicking it in the layer
								menu. You can move a part anywhere inside the center circle.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(
								styles,
								assetNameWithType("beastBuilderSelectedPart"),
								true
							)}
						</div>
					</div>
					<div>
						All changes you make in Beast Builder are saved automatically. If
						you leave Beast Builder and return, your monster will look the same
						as you left it. The{" "}
						<div className={styles.bbButtonInText}>
							{inlineIcon(styles, AssetsUtil.getBeastBuilderButton("photo"))}
						</div>{" "}
						lets you take a photo of your current beast or change your profile
						photo. You can save up to 6 photos in your gallery.
					</div>
					<div className={styles.rowContainer}>
						<div className={styles.column6}>
							<div>
								You can edit individual parts with the buttons on the corners of
								a selected part:
							</div>
							<br />
							<div>
								{genericIcon(
									styles,
									AssetsUtil.getBeastBuilderButton("reflectv"),
									"bbButtonSquare"
								)}{" "}
								Reflect (flip) the part across a vertical line
							</div>
							<br />
							<div>
								{genericIcon(
									styles,
									AssetsUtil.getBeastBuilderButton("reflecth"),
									"bbButtonSquare"
								)}{" "}
								Reflect (flip) the part across a horizontal line
							</div>
							<br />
							<div>
								{genericIcon(
									styles,
									AssetsUtil.getBeastBuilderButton("rotate"),
									"bbButtonSquare"
								)}{" "}
								Rotate (spin) the part
							</div>
							<br />
							<div>
								{genericIcon(
									styles,
									AssetsUtil.getBeastBuilderButton("resize"),
									"bbButtonSquare"
								)}{" "}
								Resize the part
							</div>
							<p>
								If you have selected more than one part, you can reflect,
								rotate, or resize all of them at once.
							</p>
						</div>
						<div className={styles.column4}>
							{screenshot(
								styles,
								assetNameWithType("beastBuilderSingleSelectedPart")
							)}
						</div>
					</div>
					<div>
						<p>
							At the bottom of your screen, there are more buttons to edit
							individual parts:
						</p>
						<div>
							{genericIcon(
								styles,
								AssetsUtil.getBeastBuilderButton("copy"),
								"bbButtonSquare"
							)}{" "}
							Make a copy of the part
						</div>
						<br />
						<div>
							{genericIcon(
								styles,
								AssetsUtil.getBeastBuilderButton("trash"),
								"bbButtonSquare"
							)}{" "}
							Delete the part
						</div>
						<br />
						<div>
							{genericIcon(
								styles,
								AssetsUtil.getBeastBuilderButton("palette"),
								"bbButtonSquare"
							)}{" "}
							Open the color selection tool
							<br />
							{screenshot(styles, "bbColorSelectTool")}
							<p>
								Click any color to choose it, and click the arrows to see more
								color options Some parts cannot change color.
							</p>
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "beast-layering",
			title: "Layering",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.rowContainer}>
						<div className={styles.column4}>
							<p>
								The layer menu on the right side of the screen shows how all of
								the parts of your monster are stacked on top of each other.
							</p>
							<p>
								Select any part to change the layer. Parts that are behind other
								parts may not be visible. You can see and select any part of our
								monster in the layer menu, even if some parts are not visible.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(
								styles,
								assetNameWithType("beastBuilderLayerMenu"),
								true
							)}
						</div>
					</div>
					<div>
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerTop"),
							<span>Sends the part to the top layer</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerUp"),
							<span>Sends the part up one layer</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerDown"),
							<span>Sends the part down one layer</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerBottom"),
							<span>Sends the part to the bottom layer</span>,
							styles.bbButtonSquare
						)}
						<br />
					</div>
				</div>
			),
		},
		{
			hash: "beast-shortcuts",
			title: "Keyboard Shortcuts",
			titleLevel: 3,
			contents: (
				<div>
					<p>
						If you are using a device with a keyboard, you can also use these
						shortcuts.
					</p>
					<div className={styles.tabOnly}>
						<b>Select All:</b> Ctrl-A (Windows) or Cmd-A (Mac)
						<br />
						Holding down Ctrl (Window) or Cmd (Mac) while clicking on individual
						parts will let you select multiple parts together.
						<br />
						<b>Undo:</b> Ctrl-Z (Windows) or Cmd-Z (Mac)
						<br />
						<b>Redo:</b> Ctrl-Y (Windows) or Shift-Cmd-Z (Mac)
						<br />
						<b>Delete selected part:</b> Delete or Backspace
						<br />
						<b>Send part up one layer:</b> Page Up
						<br />
						<b>Send part down one layer:</b> Page Down
						<br />
					</div>
				</div>
			),
		},
	];
};

module.exports = {
	getCopy,
};
